var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.clueList),function(item){return _c('div',{key:item.id},[(item.category==5)?_c('baseWBItem',{attrs:{"report":item}}):_c('baseItem',{attrs:{"type":2,"report":item}})],1)}))}
var staticRenderFns = []

export { render, staticRenderFns }